<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <el-form label-width="130px"
               style="margin-top: 5px"
               :model="dataForm">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业名称">
              <el-input v-model="dataForm.companyName"
                        :disabled="true"
                        placeholder=" "
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model="dataForm.socialCreditCode"
                        :disabled="true"
                        placeholder=" "
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="认证类型">
              <el-input v-model="dataForm.authentTypeName"
                        :disabled="true"
                        placeholder=" "
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- todo -->
            <el-form-item label="所属行业">
              <el-select v-model="dataForm.value"
                         style="width: 30%;float:left"
                         :disabled="true"
                         placeholder=" ">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.value"
                         style="width: 65%;float:left;margin-left:5%"
                         :disabled="true"
                         placeholder=" ">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业地址">
              <el-select v-model="dataForm.provinceId"
                         style="width: 30%;float:left"
                         :disabled="true"
                         placeholder=" ">
                <!-- 省 -->
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.cityId"
                         style="width: 30%;float:left;margin-left:5%"
                         :disabled="true"
                         placeholder=" ">
                <!-- 市 -->
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.areaId"
                         style="width: 30%;float:left;margin-left:5%"
                         :disabled="true"
                         placeholder=" ">
                <!-- 区 -->
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="dataForm.address"
                        placeholder=" "
                        :disabled="true"
                        style="width: 100%;margin-top:10px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业法人">
              <el-input v-model="dataForm.legaPerson"
                        placeholder=" "
                        :disabled="true"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="法人身份证">
              <el-input v-model="dataForm.legaIdcard"
                        placeholder=" "
                        :disabled="true"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照">
              <div class="demo-image__preview">
                <el-image style="width: 200px; height: 130px"
                          :src="url"
                          :preview-src-list="srcList">
                </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="法人身份证(正面)">
              <el-image style="width: 200px; height: 130px"
                        :src="url"
                        :preview-src-list="srcList">
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证(反面)">
              <div class="demo-image__preview">
                <el-image style="width: 200px; height: 130px"
                          :src="url"
                          :preview-src-list="srcList">
                </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        companyId: ''
      },
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ]
    }
  },
  methods: {
    getDateForm () {
      this.$http.get('/help/user/sys/custCompany/delete', {
        params: {
          companyId: this.dataForm.companyId
        }
      }).then(({ data: res }) => {
        this.dataForm = res.data
      }).catch(() => { })
    }
  },
  activated () {
    if (this.$route.params.check === 'attestation') {
      this.dataForm.companyId = this.$route.params.id
      this.getDateForm()
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 60px;
  margin-top: 10px;
  text-align: center;
}
</style>
<style>
.aui-content > .el-tabs > .el-tabs__content {
  padding: 10px;
}
</style>
